import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import About from "./pages/About";
import EducationExperience from "./pages/EducationExperience";
import Projects from "./pages/Projects";
import BlockPage from "./pages/BlockPage";
import NotePage from "./pages/NotePage";
import TagPage from "./pages/TagPage";
import Contact from "./pages/Contact";
import Publications from "./pages/Publications";
import ThreeGpp from "./pages/ThreeGpp";
import WhaleGnssTracking from "./pages/WhaleGnssTracking";
import UnderwaterMimoStory from "./pages/UnderwaterMimoStory";
import NrNtnTestbedStory from "./pages/NrNtnTestbedStory";
import LeoPntStory from "./pages/LeoPntStory";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-background">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/education-experience" element={<EducationExperience />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/tag/:tag" element={<TagPage />} />
            <Route path="/projects/:blockSlug" element={<BlockPage />} />
            {/* Rich, custom-laid-out notes. Static paths outrank the generic note route. */}
            <Route
              path="/projects/whales/whale-gnss-dead-reckoning"
              element={<WhaleGnssTracking />}
            />
            <Route
              path="/projects/underwater-comms/hybrid-acoustic-mi-mimo"
              element={<UnderwaterMimoStory />}
            />
            <Route
              path="/projects/leo-pnt/differential-doppler-leo"
              element={<LeoPntStory />}
            />
            <Route
              path="/projects/satellite-comms/nr-ntn-testbed"
              element={<NrNtnTestbedStory />}
            />
            <Route
              path="/projects/satellite-comms/3gpp-standards-work"
              element={<ThreeGpp />}
            />
            <Route path="/projects/:blockSlug/:noteSlug" element={<NotePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/publications" element={<Publications />} />
            <Route
              path="/3gpp"
              element={<Navigate to="/projects/satellite-comms/3gpp-standards-work" replace />}
            />
          </Routes>
        </main>
        <Footer />
        <ToastContainer theme="dark" />
      </div>
    </Router>
  );
};

export default App;
